import { Link, useLocation } from "react-router-dom";
import { LayoutGrid, PlusSquare, List, Palette, FolderOpen, Users, Shield, LogOut } from "lucide-react";

const baseNavItems = [
  { path: "/", label: "Dashboard", icon: LayoutGrid },
  { path: "/orders/new", label: "New Order", icon: PlusSquare },
  { path: "/orders", label: "Orders", icon: List },
  { path: "/customers", label: "Customers", icon: Users },
  { path: "/fabrics", label: "Fabrics", icon: Palette },
  { path: "/collections", label: "Collections", icon: FolderOpen },
];

const adminNavItems = [
  { path: "/users", label: "Users", icon: Shield },
];

export default function Layout({ children, user, onLogout }) {
  const location = useLocation();
  
  const isSuperAdmin = user?.role === "super_admin";
  const navItems = isSuperAdmin ? [...baseNavItems, ...adminNavItems] : baseNavItems;

  return (
    <div className="min-h-screen bg-[#F5F5F0] flex flex-col">
      <header className="bg-white border-b border-[#D6D6CF] px-6 md:px-12 py-4 no-print" data-testid="main-header">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
            <img src="/tinkah-logo.png" alt="TINKAH" className="h-10 w-auto" />
          </Link>
          
          <div className="flex items-center gap-4">
            <nav className="flex gap-1" data-testid="main-nav">
              {navItems.map((item) => {
                const isActive = location.pathname === item.path || 
                  (item.path !== "/" && location.pathname.startsWith(item.path));
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                    className={`flex items-center gap-2 px-4 py-2 font-['Space_Mono'] text-xs tracking-widest uppercase transition-all duration-200 ${
                      isActive
                        ? "text-[#9F7D23] bg-[rgba(159,125,35,0.08)] border-b-2 border-[#9F7D23]"
                        : "text-[#5C4D24] hover:text-[#9F7D23] hover:bg-[rgba(159,125,35,0.04)]"
                    }`}
                  >
                    <item.icon className="w-4 h-4" />
                    <span className="hidden md:inline">{item.label}</span>
                  </Link>
                );
              })}
            </nav>
            
            {/* User Menu */}
            <div className="flex items-center gap-3 pl-4 border-l border-[#D6D6CF]">
              <div className="text-right hidden sm:block">
                <p className="font-['Space_Mono'] text-xs text-[#5C4D24]">{user?.name}</p>
                <p className="font-['Space_Mono'] text-[10px] text-[#8B7536] uppercase tracking-widest">
                  {isSuperAdmin ? "Admin" : "Sales"}
                </p>
              </div>
              <button
                onClick={onLogout}
                data-testid="logout-btn"
                className="p-2 text-[#8B7536] hover:text-[#9F3A3A] hover:bg-[#9F3A3A]/10 transition-colors"
                title="Logout"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-7xl mx-auto w-full px-6 md:px-12 py-8">
        {children}
      </main>

      <footer className="border-t border-[#D6D6CF] py-6 text-center no-print" data-testid="main-footer">
        <p className="font-['Space_Mono'] text-xs tracking-[0.25em] uppercase text-[#8B7536] opacity-70">
          Bespoke Embroidery | Crafted with Intention
        </p>
      </footer>
    </div>
  );
}
